/**
 * @param {import('@nuxtjs/axios').NuxtAxiosInstance} client
 * apiPaymentUrl
 * */

export default (client, { apiPaymentUrl }) => {
  const root = `${apiPaymentUrl}/apple_pay`
  return {
    applePayValidation({ amount, validationURL }) {
      const url = `${root}/validate`
      const data = {
        amount,
        method: 'applepay_h2h',
        validation_url: validationURL,
      }
      return client.post(url, data)
    },

    applePayPay({ pmntId, tokenData }) {
      const url = `${root}/pay`
      const data = {
        pmntId,
        method: 'applepay_h2h',
        token_data: tokenData,
      }

      return client.post(url, data)
    },
  }
}
